import styled from "styled-components";

export const Image = styled.img`
    width: ${props => props.sizes};
    height: ${props =>props.sizes};
    border-radius: 50%;
`;